/** Main entry point **/
import React, { Suspense, lazy } from "react";
import { Switch, Route } from "react-router-dom";

import Header from "containers/Header/Header";

import ErrorsContainer from "containers/Errors/Errors";
import TourContainer from "containers/Tour/Tour";
import CollaborateTourContainer from "containers/Tour/CollaborateTour";
import SenseTourContainer from "containers/Tour/SenseTour";
import ExploreTourContainer from "containers/Tour/ExploreTour";
import MainContainer from "containers/Main/Main";
import ChatGPTContainer from "components/ChatGPT/ChatGPT";
// import NextWrapperContainer from "containers/Next/NextWrapper";

import { connect } from "react-redux";
import { compose } from "redux";

import { getIsMarketplaceDemo } from "containers/MarketplaceDemo/reducer";
import { getIsMarketplace } from "containers/Marketplace/reducer";
import { getIsMonitorMobile } from "containers/MonitoringMobile/reducer";
import { getIsCommunityMarket } from "containers/CommunityMarket/MarketReducer";

const HomeContainer = lazy(() => import("containers/Home/Home"));
const DeployContainer = lazy(() => import("containers/Deploy/Deploy"));
const NotFoundPage = lazy(() => import("containers/NotFoundPage"));
const BlueprintContainer = lazy(() => import("containers/Blueprint/Blueprint"));
const NextBlueprintContainer = lazy(() => import("containers/Next/Blueprint/Blueprint"));
const BusinessContainer = lazy(() => import("containers/Business/Business"));
const ContestContainer = lazy(() => import("containers/Contest/Contest"));
const AccountSettings = lazy(() => import("containers/AccountSettings/AccountSettings"));
const AWSHelp = lazy(() => import("containers/AWSHelp/AWSHelp"));
const DatasetContainer = lazy(() => import("containers/Dataset/Dataset"));
const GalleryContainer = lazy(() => import("containers/Gallery/Gallery"));
const ReportContainer = lazy(() => import("containers/Report/Report"));
const NextWrapperContainer = lazy(() => import("containers/Next/NextWrapper"));
const DashboardHolderContainer = lazy(() => import("containers/Next/Dashboard/DashboardHolder"));
const TransformContainer = lazy(() => import("containers/Next/Transform/Transform"));
const TableauExploreContainer = lazy(() => import("containers/Next/Tableau/TableauExplore"));
const GoogleExploreContainer = lazy(() => import("containers/Next/Google/GoogleExplore"));
const ClusterChartContainer = lazy(() => import("containers/ClusterChart/ClusterChart"));
const GroupContainer = lazy(() => import("containers/Group/Group"));
const WizardContainer = lazy(() => import("containers/Wizard/Wizard"));
const UnifiedProjectContainer = lazy(() => import("containers/UnifiedProject/UnifiedProject"));
const MonitoringMobileContainer = lazy(() => import("containers/MonitoringMobile/MonitoringMobile"));
const ConsumerContainer = lazy(() => import("containers/Consumer/Consumer"));
const MarketplaceDemoContainer = lazy(() => import("containers/MarketplaceDemo/Marketplace"));
const MarketplaceContainer = lazy(() => import("containers/Marketplace/Marketplace"));
const OptimizerCreator = lazy(() => import("containers/OptimizerCreator/OptimizerCreator"));
const MarketContainer = lazy(() => import("containers/Market/Market"));
const TaskContainer = lazy(() => import("containers/Tasks/Task"));
const ExploreTaskContainer = lazy(() => import("containers/Tasks/ExploreTask"));
const LookerSetupContainer = lazy(() => import("containers/LookerSettings/LookerSetup"));
const CommunityMarket = lazy(() => import("components/CommunityMarket/Market"));
const AibleAgent = lazy(() => import("components/AibleAgent/AibleAgent"));
const VideoTemplate = lazy(() => import("components/Templates/VideoTemplate"));
const ChatTemplate = lazy(() => import("components/Templates/ChatTemplate"));
const ClawView = lazy(() => import("components/Claw/ClawView"));
const AiqView = lazy(() => import("components/AiqView/AiqView"));

import ProtectedRoute from "components/Utils/ProtectedRoute";

import App from "components/App/App";
import LoadingIndicator from "components/LoadingIndicator/LoadingIndicator";

import * as nextReducer from "containers/Next/NextReducer";
import * as globalReducer from "containers/App/reducer";
import * as loginReducer from "containers/Login/reducer";

// import tableau from "utils/tableau-extensions-1.latest";

class ProtectedAppContainer extends React.PureComponent {
  renderDashboard() {
    const { lookerCount, lookerDashboardId } = this.props;

    return (
      <div
        style={{
          height: "100vh",
          minWidth: "50%",
          display: "flex",
          justifyContent: "center",
          alignItems: "center"
        }}
        key={lookerCount}
      >
        {lookerCount >= 1 ? (
          <iframe
            src={"https://aible.cloud.looker.com/embed/dashboards/" + lookerDashboardId}
            style={{
              height: "100%",
              width: "100%",
              display: "block"
            }}
          />
        ) : (
          <LoadingIndicator style={{ margin: "0px" }} />
        )}
      </div>
    );
  }

  renderRoutes() {
    return (
      <App>
        <Header />
        <ErrorsContainer />
        <TourContainer />
        <CollaborateTourContainer />
        <SenseTourContainer />
        <ExploreTourContainer />
        <MainContainer>
          <Suspense fallback={<LoadingIndicator style={{ height: "calc(100vh - 60px)", margin: "40vh auto" }} />}>
            <Switch>
              <ProtectedRoute exact path={"/"} component={HomeContainer} />
              <ProtectedRoute exact path={"/project-resource/public/extension.loader"} component={HomeContainer} />
              <ProtectedRoute path={"/lookerSetup"} component={LookerSetupContainer} />
              <ProtectedRoute path={"/cluster"} component={ClusterChartContainer} />
              <ProtectedRoute path={"/optimizer"} component={OptimizerCreator} />
              <ProtectedRoute path={"/accounts"} component={AccountSettings} />
              <ProtectedRoute path={"/accounts"} component={AccountSettings} />
              <ProtectedRoute path={"/report/:reportId"} component={ReportContainer} />
              <ProtectedRoute path={"/gallery/:datasetId"} component={GalleryContainer} />
              <ProtectedRoute
                path={"/next/:datasetId/:reportId/:blueprintId"}
                component={NextWrapperContainer}
                allowUiState={"SHARE_LINK"}
              />
              <ProtectedRoute path={"/next/:datasetId/:reportId"} component={NextWrapperContainer} />
              <ProtectedRoute path={"/chataible/:nextId"} component={ChatGPTContainer} />
              <ProtectedRoute path={"/dashboard/:datasetId/:reportId"} component={DashboardHolderContainer} />
              <ProtectedRoute path={"/nextBlueprint/:blueprintId"} component={NextBlueprintContainer} />
              <ProtectedRoute path={"/transform/:datasetId"} component={TransformContainer} />
              <ProtectedRoute path={"/dataset/:datasetId"} component={DatasetContainer} />
              <ProtectedRoute path={"/business/:id"} component={BusinessContainer} />
              <ProtectedRoute path={"/project/:id/:nextId"} component={UnifiedProjectContainer} />
              <ProtectedRoute path={"/project/:id"} component={UnifiedProjectContainer} />
              <ProtectedRoute path={"/project_next/:nextId"} component={TableauExploreContainer} />
              <ProtectedRoute path={"/google/:datasetId"} component={GoogleExploreContainer} />
              <ProtectedRoute
                path={"/explore/:nextId/:searchColumn/:searchValue"}
                component={TableauExploreContainer}
              />
              <ProtectedRoute path={"/collaborate"} component={ConsumerContainer} />
              <ProtectedRoute path={"/group/:id"} component={GroupContainer} />
              <ProtectedRoute path={"/contest/:id/"} component={ContestContainer} />
              <ProtectedRoute path={"/deploy/:id/:modelId"} component={DeployContainer} />
              <ProtectedRoute path={"/run/:id"} component={WizardContainer} />
              <ProtectedRoute path={"/eBlueprint/:blueprintId/"} component={BlueprintContainer} />
              <ProtectedRoute path={"/blueprint/:blueprintId/"} component={WizardContainer} />
              <ProtectedRoute path={"/task/:taskId/"} component={TaskContainer} />
              <ProtectedRoute path={"/exploreTask/:taskId/"} component={ExploreTaskContainer} />
              <ProtectedRoute path={"/market"} component={MarketContainer} />
              <ProtectedRoute path={"/agent/:agentId/:viewType"} component={AibleAgent} />
              <ProtectedRoute path={"/agent"} component={AibleAgent} />
              <ProtectedRoute path={"/templates/:templateId"} component={VideoTemplate} />
              <ProtectedRoute path={"/chatTemplate/:blueprintId"} component={ChatTemplate} />
              <ProtectedRoute path={"/safeClaw/:agentId/:viewType"} component={ClawView} />
              <ProtectedRoute path={"/aiq/:agentId"} component={AiqView} />
              {getIsMarketplaceDemo() && (
                <ProtectedRoute path={"/marketplace_v1/"} component={MarketplaceDemoContainer} />
              )}
              {getIsMarketplace() && <ProtectedRoute path={"/marketplace/"} component={MarketplaceContainer} />}
              {getIsMonitorMobile() && (
                <ProtectedRoute path={"/monitor-mobile"} component={MonitoringMobileContainer} />
              )}
              {getIsCommunityMarket() && <ProtectedRoute path={"/community_market/"} component={CommunityMarket} />}
              <Route exact path={"/help/aws"} component={AWSHelp} />
            </Switch>
          </Suspense>
        </MainContainer>
      </App>
    );
  }

  render() {
    const { lookerSDK } = this.props;

    const urlPath = window?.looker_SDK?._lookerHostData.route;
    const params = urlPath === undefined ? undefined : urlPath.split("/");

    const isChatAible = params?.[1] === "ChatAible";

    return lookerSDK === undefined ? (
      this.renderRoutes()
    ) : isChatAible === true ? (
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          overflow: "hidden"
        }}
      >
        {this.renderDashboard("50%")}
        <div style={{ minWidth: "50%", height: "100%" }}>{this.renderRoutes()}</div>
      </div>
    ) : (
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          overflow: "hidden"
        }}
      >
        {this.renderDashboard()}
        <div style={{ minWidth: "50%", height: "100%" }}>{this.renderRoutes()}</div>
      </div>
    );
  }
}

const mapDispatchToProps = (dispatch, ownProps) => ({});

const mapStateToProps = (state, ownProps) => ({
  lookerCount: nextReducer.getLookerCount(state),
  lookerDashboardId: globalReducer.getLookerDashboardId(state),
  lookerSDK: loginReducer.getLookerAPIClient(state)
});

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export default compose(withConnect)(ProtectedAppContainer);
